export default __webpack_public_path__ + "static/media/slide-image-1_1728x.abd72258.jpg";